import { Link, useNavigate } from 'react-router-dom';
import { Package, Menu, X, User, LogOut } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
    setMobileMenuOpen(false);
  };

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <Package className="h-8 w-8 text-primary-600" />
            <span className="text-xl font-bold text-primary-900">TUMANASI</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-12">
            <Link to="/" className="text-gray-700 hover:text-primary-600 transition-colors font-medium text-base">
              Home
            </Link>
            <Link to="/pricing" className="text-gray-700 hover:text-primary-600 transition-colors font-medium text-base">
              Pricing
            </Link>
            <Link to="/track" className="text-gray-700 hover:text-primary-600 transition-colors font-medium text-base">
              Track
            </Link>

            {isAuthenticated ? (
              <>
                <Link
                  to={user?.role?.toLowerCase() === 'admin' || user?.user_type?.toLowerCase() === 'admin' ? '/admin' : '/rider/dashboard'}
                  className="text-gray-700 hover:text-primary-600 transition-colors flex items-center gap-2 font-medium"
                >
                  <User size={18} />
                  <span>{user?.name || (user?.role?.toLowerCase() === 'admin' || user?.user_type?.toLowerCase() === 'admin' ? 'Admin' : 'Dashboard')}</span>
                </Link>
                <button
                  onClick={handleLogout}
                  className="text-gray-700 hover:text-red-600 transition-colors flex items-center gap-2 font-medium"
                >
                  <LogOut size={18} />
                  <span>Logout</span>
                </button>
              </>
            ) : (
              <Link
                to="/login"
                className="bg-white border-2 border-primary-600 text-primary-600 px-8 py-2.5 rounded-lg hover:bg-primary-50 transition-colors font-semibold text-base"
              >
                Login
              </Link>
            )}
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden text-gray-700 hover:text-primary-600"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 space-y-3 border-t border-gray-200">
            <Link
              to="/"
              onClick={() => setMobileMenuOpen(false)}
              className="block px-4 py-3 text-gray-700 hover:bg-gray-100 rounded font-medium"
            >
              Home
            </Link>
            <Link
              to="/pricing"
              onClick={() => setMobileMenuOpen(false)}
              className="block px-4 py-3 text-gray-700 hover:bg-gray-100 rounded font-medium"
            >
              Pricing
            </Link>
            <Link
              to="/track"
              onClick={() => setMobileMenuOpen(false)}
              className="block px-4 py-3 text-gray-700 hover:bg-gray-100 rounded font-medium"
            >
              Track
            </Link>
            <Link
              to="/book"
              onClick={() => setMobileMenuOpen(false)}
              className="block px-4 py-3 bg-primary-600 text-white hover:bg-primary-700 rounded font-medium"
            >
              Book Now
            </Link>

            {isAuthenticated ? (
              <>
                <div className="border-t border-gray-200 pt-3 mt-3">
                  <Link
                    to={user?.role?.toLowerCase() === 'admin' || user?.user_type?.toLowerCase() === 'admin' ? '/admin' : '/rider/dashboard'}
                    onClick={() => setMobileMenuOpen(false)}
                    className="block px-4 py-3 text-gray-700 hover:bg-gray-100 rounded font-medium"
                  >
                    {user?.role?.toLowerCase() === 'admin' || user?.user_type?.toLowerCase() === 'admin' ? 'Admin Dashboard' : 'Dashboard'}
                  </Link>
                </div>
                <button
                  onClick={handleLogout}
                  className="block w-full text-left px-4 py-3 text-red-600 hover:bg-gray-100 rounded font-medium"
                >
                  Logout
                </button>
              </>
            ) : (
              <div className="border-t border-gray-200 pt-3 mt-3">
                <Link
                  to="/login"
                  onClick={() => setMobileMenuOpen(false)}
                  className="block px-4 py-3 text-gray-700 hover:bg-gray-100 rounded font-medium"
                >
                  Login
                </Link>
              </div>
            )}
          </div>
        )}
      </div>
    </nav>
  );
}
